import { ScrollView as GSScrollView } from "@gluestack-ui/themed";

import { ScrollViewProps } from "./types";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { useMemo } from "react";
import { useDimensions } from "@repo/core/hooks/useDimensions";

export const ScrollView = ({
  children,
  flex = 1,
  marginBottom,
  keyboardShouldPersistTaps = "handled",
  bgColor = "$backgroundLigh100",
  hiddenVerticalScrollIndicator,
  ...props
}: ScrollViewProps) => {
  const { isWeb } = useDeviceType();
  const { isMobile } = useDimensions();

  const customMarginBottom = useMemo(() => {
    if (marginBottom !== undefined) {
      return marginBottom;
    }

    return isMobile && isWeb ? "$20" : "$0";
  }, [marginBottom, isMobile, isWeb]);

  const showsVerticalScrollIndicator = useMemo(() => {
    if (hiddenVerticalScrollIndicator) {
      return false;
    }

    return isMobile ? false : true;
  }, [hiddenVerticalScrollIndicator, isMobile]);

  return (
    <GSScrollView
      flex={flex}
      bgColor={bgColor}
      keyboardShouldPersistTaps={keyboardShouldPersistTaps}
      showsVerticalScrollIndicator={showsVerticalScrollIndicator}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      pb={customMarginBottom}
      {...props}
    >
      {children}
    </GSScrollView>
  );
};
